import { render, staticRenderFns } from "./Partner-Promotions.vue?vue&type=template&id=3818315e"
import script from "./Partner-Promotions.vue?vue&type=script&lang=js"
export * from "./Partner-Promotions.vue?vue&type=script&lang=js"
import style0 from "./Partner-Promotions.vue?vue&type=style&index=0&id=3818315e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports